/**
 * @fileoverview Set city info admin page outer level component
 *
 * Components: CityInfoGrid, ChargerInfoForm
 */

import React, { useState } from "react";
import CityInfoGrid from "components/admin-page/CityInfoGrid";
import ChargerInfoForm from "components/admin-page/ChargerInfoForm";
import useAuthStore from "store/useAuthStore";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Button } from "components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import MasterAccessInfoForm from "components/admin-page/MasterAccessInfoForm";
const AdminSetInfo = () => {
  const { user } = useAuthStore();

  const [activeTab, setActiveTab] = useState("city");
  const [cityDirty, setCityDirty] = useState(false);
  const [chargerDirty, setChargerDirty] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingTab, setPendingTab] = useState(null);

  const handleTabChange = (nextValue) => {
    if (nextValue === activeTab) return;
    const leavingTab = activeTab;
    const isDirty =
      leavingTab === "city"
        ? cityDirty
        : leavingTab === "charger"
        ? chargerDirty
        : false;
    if (isDirty) {
      setPendingTab(nextValue);
      setConfirmOpen(true);
      return;
    }
    setActiveTab(nextValue);
  };
  const handleConfirmDiscard = () => {
    if (pendingTab) {
      setActiveTab(pendingTab);
    }
    setPendingTab(null);
    setConfirmOpen(false);
  };

  const handleCancelDiscard = () => {
    setPendingTab(null);
    setConfirmOpen(false);
  };

  return (
    <div className="container mx-auto py-6">
      {!user ? (
        <div>Log in with a user!</div>
      ) : (
        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-2xl font-semibold text-primary">
              Set City Information
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Tabs
              value={activeTab}
              className="w-full"
              onValueChange={handleTabChange}>
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="city">City Information</TabsTrigger>
                <TabsTrigger value="charger">Charger Information</TabsTrigger>
                <TabsTrigger value="master-access">
                  Master Access Information
                </TabsTrigger>
              </TabsList>
              <TabsContent value="city">
                <CityInfoGrid onDirtyChange={setCityDirty} />
              </TabsContent>
              <TabsContent value="charger">
                <ChargerInfoForm onDirtyChange={setChargerDirty} />
              </TabsContent>
              <TabsContent value="master-access">
                <MasterAccessInfoForm />
              </TabsContent>
            </Tabs>
            <Dialog
              open={confirmOpen}
              onOpenChange={setConfirmOpen}>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Discard unsaved changes?</DialogTitle>
                  <DialogDescription>
                    You have unsaved changes on this tab. If you switch tabs
                    now, your changes will be lost.
                  </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex gap-2 justify-end">
                  <Button
                    variant="secondary"
                    onClick={handleCancelDiscard}>
                    Cancel
                  </Button>
                  <Button
                    variant="destructive"
                    onClick={handleConfirmDiscard}>
                    Discard and switch
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default AdminSetInfo;
